var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_5289_2259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.99929 8.5C1.79455 8.5 0 6.70545 0 4.49929C0 2.29313 1.79455 0.5 3.99929 0.5C6.20402 0.5 7.99858 2.29455 7.99858 4.49929C7.99858 6.70402 6.20402 8.49858 3.99929 8.49858V8.5Z",
    fill: "#3395FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.00084 2.87988C3.9396 2.87988 3.88833 2.89982 3.84845 2.93828C3.80429 2.98243 3.78008 3.04937 3.78008 3.12628V4.20158C3.77866 4.40383 3.77723 4.61319 3.78293 4.81828C3.78293 4.87098 3.80572 4.93507 3.83848 4.9835C3.88548 5.05186 3.9809 5.0775 4.07205 5.04616C4.16463 5.01341 4.22017 4.93222 4.22017 4.82825C4.22017 4.2614 4.22017 3.69455 4.22017 3.1277C4.22017 2.97673 4.13472 2.87988 4.00084 2.87988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.77576 6.02596C3.83416 6.08577 3.91249 6.11853 3.99652 6.11853H3.99795C4.1717 6.11853 4.3127 5.97896 4.31413 5.80662C4.31413 5.63286 4.17455 5.49044 4.00222 5.48901H3.99937C3.91676 5.48901 3.83985 5.52177 3.78004 5.58017C3.72022 5.63998 3.68604 5.71832 3.68604 5.80235C3.68604 5.88638 3.71737 5.96614 3.77719 6.02596H3.77576Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5289_2259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningICON.21323797003d2f289d6380e0f28cfe2d.svg";
export { ForwardRef as ReactComponent };